import React, { useEffect, useRef, useState } from "react";
import { Play, Pause, Radio } from "lucide-react";
import axios from "axios";

const B = process.env.REACT_APP_BACKEND_URL;

export const RadioPlayerBar = ({ stationId }) => {
  const [np, setNp] = useState(null);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!stationId) return;
    const load = () => axios.get(`${B}/api/public/nowplaying/${stationId}`).then((r) => setNp(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [stationId]);

  if (!stationId || !np) return null;
  const streamUrl = np.listen_live_url || "";

  const toggle = () => {
    if (!streamUrl) return;
    if (!audioRef.current) {
      audioRef.current = new Audio(streamUrl);
      audioRef.current.crossOrigin = "anonymous";
    }
    if (playing) { audioRef.current.pause(); setPlaying(false); }
    else { audioRef.current.play().then(() => setPlaying(true)).catch(() => {}); }
  };

  return (
    <div data-testid="radio-player-bar"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center gap-4 px-4 sm:px-8 py-3"
      style={{ background: "#1C1A17", color: "#F4F1ED", fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <button onClick={toggle} data-testid="radio-play-btn" disabled={!streamUrl}
        className="h-11 w-11 rounded-full flex items-center justify-center shrink-0 transition-transform hover:scale-105 disabled:opacity-40"
        style={{ background: "#E05C3A" }}>
        {playing ? <Pause className="h-5 w-5 text-white" /> : <Play className="h-5 w-5 text-white ml-0.5" />}
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-semibold" style={{ color: "#E05C3A" }}>
          <span className={`h-1.5 w-1.5 rounded-full ${playing ? "animate-pulse" : ""}`} style={{ background: "#E05C3A" }} />
          On Air · {np.station_name || "Radio"}
        </div>
        <div className="text-sm truncate" data-testid="radio-now-playing">
          {np.track ? `${np.track.artist} — ${np.track.title}` : "Live stream"}
        </div>
      </div>
      <Radio className="h-5 w-5 opacity-40 hidden sm:block" />
    </div>
  );
};
